"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    __NR_ATTEMPTED?: boolean;
    NREUM?: {
      info?: object;
      init?: object;
      loader_config?: object;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any; // Allow other properties
    };
    newrelic?: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any; // Allow any properties
    };
  }
}

export const NewRelicBrowserInitializer: React.FC = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    if (window.__NR_ATTEMPTED) return;

    // Mark attempt early to prevent retries
    window.__NR_ATTEMPTED = true;

    if (typeof window.NREUM !== "object" || window.NREUM === null) {
      window.NREUM = {};
    }

    const config = {
      loader_config: {
        accountID: process.env.NEXT_PUBLIC_NEWRELIC_ACCOUNT_ID,
        trustKey: process.env.NEXT_PUBLIC_NEWRELIC_TRUST_ID,
        agentID: process.env.NEXT_PUBLIC_NEWRELIC_AGENT_ID,
        licenseKey: process.env.NEXT_PUBLIC_NEWRELIC_LICENSE_KEY,
        applicationID: process.env.NEXT_PUBLIC_NEWRELIC_APP_ID,
      },
      info: {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: process.env.NEXT_PUBLIC_NEWRELIC_LICENSE_KEY,
        applicationID: process.env.NEXT_PUBLIC_NEWRELIC_APP_ID,
        sa: 1,
      },
      init: {
        privacy: { cookies_enabled: true },
        ajax: {
          block_internal: true,
          enabled: true,
          autoStart: true,
        },
        spa: { enabled: true, autoStart: true },
      },
    };

    /*
     * Dynamically import the BrowserAgent class *here*, inside useEffect.
     * This ensures its code (and any side effects) runs only on the client.
     */
    import("@newrelic/browser-agent/loaders/browser-agent")
      .then((module) => {
        const BrowserAgent = module.BrowserAgent; // Access the class from the module exports
        if (BrowserAgent && typeof BrowserAgent === "function") {
          new BrowserAgent(config);
          //eslint-disable-next-line no-console
          console.info("✅ Initialized New Relic browser agent successfully.");
        } else {
          //eslint-disable-next-line no-console
          console.error("❌ New Relic BrowserAgent class not found in module exports.");
        }
      })
      .catch((error) => {
        //eslint-disable-next-line no-console
        console.error("❌ Failed to load New Relic browser agent module:", error);
      });
  }, []); // Empty dependency array means this runs once on mount

  return null; // This component doesn't render anything
};
